export interface FilterPreferenceResponse {
  rowKey: string;
  screenName: string;
  presetName: string;
  filterJson: string;
  isDefault: boolean;
  createdOn: string;
  lastModifiedOn: string;
}

export interface SaveFilterPreferenceRequest {
  screenName: string;
  presetName: string;
  filterJson: string;
}

export interface SaveFilterPreferenceApiResponse {
  rowKey: string;
}

/**
 * Converts a FilterPreferenceResponse to the shape expected by the UI,
 * deserializing the filterJson string back to the given filter type.
 */
export function toSavedFilterPreset<T>(response: FilterPreferenceResponse): {
  id: string;
  name: string;
  filters: T;
  isDefault: boolean;
} {
  return {
    id: response.rowKey,
    name: response.presetName,
    filters: JSON.parse(response.filterJson) as T,
    isDefault: response.isDefault,
  };
}
